import { AreaAtuacaoProcesso } from "./AreaAtuacaoProcesso";
import { AssuntoCnj } from "./AssuntoCnj";
import { ClasseProcessual } from "./ClasseProcessual";
import { FaseProcesso } from "./FaseProcesso";
import { Funcionario } from "./Funcionario"
import { GrupoProcesso } from "./GrupoProcesso";
import { Instancia } from "./Instancia";
import { OrgaoJulgador } from "./OrgaoJulgador";
import { Tribunal } from "./Tribunal";

export class Processo{
    id = 0;    
    advogado = new Funcionario();
    idAdvogado = 0;
    dataHora = new Date();
    processoNumero = '';
    assunto = '';
    distribuicao = '';
    idPessoaAutor = 0;
    reu = '';
    status = 0;
    situacao = '';
    arquivadoData = new Date();
    areaAtuacaoProcesso = new AreaAtuacaoProcesso();
    classeProcessual = new ClasseProcessual();
    assuntoCnj = new AssuntoCnj();
    faseProcesso = new FaseProcesso();
    tribunal = new Tribunal();
    orgaoJulgador = new OrgaoJulgador();
    isAutor = false;    
    nomeAutor = '';
    tipoPessoa = '';
    valorCausa = 0;
    numeroProcessoAntigo = '';
    grupoProcesso = new GrupoProcesso();
    instancia = new Instancia();
    dataDistribuicao = new Date();
    dataHoraUltimaAtualizacao = new Date();
    dataHoraSistema = new Date();
    dataPeticaoHabilitadao = new Date();
    
    advogados = [];
}